import { useQuery } from '@tanstack/react-query';
import { getCertificates } from '../../api/me';
import { learnerKeys } from '../../pages/learner/DashboardPage';
import type { IssuedCertificate } from '../../types/learnerCertificates';

export interface UseCertificatesResult {
  certificates: IssuedCertificate[];
  isLoading: boolean;
  isError: boolean;
  refetch: () => void;
}

export function useCertificates(): UseCertificatesResult {
  const query = useQuery({
    queryKey: learnerKeys.certificates,
    queryFn: getCertificates,
    staleTime: 30_000,
    retry: (count, err) => {
      const status = (err as { response?: { status?: number } })?.response?.status;
      return status !== 401 && status !== 403 && count < 2;
    },
  });

  return {
    certificates: query.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: query.refetch,
  };
}
